import { getData, postData, putData } from "../../../services/api";

export const getBranchList = async () => {
  const res = await getData("dbms/branchs");
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getDepartmentsList = async () => {
  const res = await getData("dbms/departments");
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getBudgetYearsList = async () => {
  const res = await getData("dbms/budget-years");
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsList = async () => {
  const res = await getData("dbms/materials");
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsBalanceList = async (
  branchNo,
  department,
  documentType
) => {
  const res = await getData(
    `material/balance?branchNo=${branchNo}&department=${department}${
      documentType ? `&documentType=${documentType}` : ""
    }`
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsBorrowedList = async (branchNo, department) => {
  const res = await getData(
    `material/borrowed?branchNo=${branchNo}&department=${department}`
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsBrokenRepairList = async (branchNo, department) => {
  const res = await getData(
    `material/broken-repair?branchNo=${branchNo}&department=${department}`
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsBrokenCutoffsList = async (branchNo, department) => {
  const res = await getData(
    `material/broken-cutoff?branchNo=${branchNo}&department=${department}`
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsExpensesList = async (q, b,d, page, rowsPerPage) => {
  let _params = `${q ? "&expensesNo=" + q : ""}${
    b ? (b !== "all" ? "&branchNo=" + b : "") : ""
  }${d ? (d !== "all" ? "&documentType=" + d : "") : ""}`;
  const res = await getData(
    `material/expenses?page=${page}&limit=${rowsPerPage}`,
    _params
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsExpensesDetail = async (id) => {
  const res = await getData(`material/expenses/${id}`);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const addMaterialsExpenses = async (body) => {
  const res = await postData(`material/expenses`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const updateMaterialsExpenses = async (body, id) => {
  const res = await putData(`material/expenses/${id}`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsReturnsList = async (q, b, page, rowsPerPage) => {
  let _params = `${q ? "&returnsNo=" + q : ""}${
    b ? (b !== "all" ? "&branchNo=" + b : "") : ""
  }`;
  const res = await getData(
    `material/returns?page=${page}&limit=${rowsPerPage}`,
    _params
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsReturnsDetail = async (id) => {
  const res = await getData(`material/returns/${id}`);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const addMaterialsReturns = async (body) => {
  const res = await postData(`material/returns`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const updateMaterialsReturns = async (body, id) => {
  const res = await putData(`material/returns/${id}`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsTransfersList = async (q, b, page, rowsPerPage) => {
  let _params = `${q ? "&transfersNo=" + q : ""}${
    b ? (b !== "all" ? "&branchNo=" + b : "") : ""
  }`;
  const res = await getData(
    `material/transfers?page=${page}&limit=${rowsPerPage}`,
    _params
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsTransfersDetail = async (id) => {
  const res = await getData(`material/transfers/${id}`);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const addMaterialsTransfers = async (body) => {
  const res = await postData(`material/transfers`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const updateMaterialsTransfers = async (body, id) => {
  const res = await putData(`material/transfers/${id}`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsReceiveList = async (q, b, page, rowsPerPage) => {
  let _params = `${q ? "&receiveNo=" + q : ""}${
    b ? (b !== "all" ? "&branchNo=" + b : "") : ""
  }`;
  const res = await getData(
    `material/receives?page=${page}&limit=${rowsPerPage}`,
    _params
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsReceiveDetail = async (id) => {
  const res = await getData(`material/receives/${id}`);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const addMaterialsReceive = async (body) => {
  const res = await postData(`material/receives`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const updateMaterialsReceive = async (body, id) => {
  const res = await putData(`material/receives/${id}`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsLendsList = async (q, b, d, page, rowsPerPage) => {
  let _params = `${q ? "&lendsNo=" + q : ""}${
    b ? (b !== "all" ? "&branchNo=" + b : "") : ""
  }${d ? (d !== "all" ? "&documentType=" + d : "") : ""}`;
  const res = await getData(
    `material/lends?page=${page}&limit=${rowsPerPage}`,
    _params
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const getMaterialsLendsDetail = async (id) => {
  const res = await getData(`material/lends/${id}`);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const addMaterialsLends = async (body) => {
  const res = await postData(`material/lends`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const updateMaterialsLends = async (body, id) => {
  const res = await putData(`material/lends/${id}`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsStock = async (
  q,
  b,
  d,
  sum,
  m,
  ms,
  page,
  rowsPerPage
) => {
  let _params = `${q ? "&lot=" + q : ""}${
    b ? (b !== "all" ? "&branchNo=" + b : "") : ""
  }${d ? (d !== "all" ? "&department=" + d : "") : ""}${
    m ? (m !== "all" ? "&materialNo=" + m : "") : ""
  }${ms ? (ms !== "all" ? "&materialStatus=" + ms : "") : ""}${
    sum ? "&sumLot=" + sum : ""
  }`;
  const res = await getData(
    `material/stock?page=${page}&limit=${rowsPerPage}` + _params
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsRepairList = async (q, b, page, rowsPerPage) => {
  let _params = `${q ? "&lendsNo=" + q : ""}${
    b ? (b !== "all" ? "&branchNo=" + b : "") : ""
  }`;
  const res = await getData(
    `material/repairs?page=${page}&limit=${rowsPerPage}` + _params
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const addMaterialsRepair = async (body) => {
  const res = await postData(`material/repairs`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsRepairDetail = async (id) => {
  const res = await getData(`material/repairs/${id}`);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const updateMaterialsRepair = async (body, id) => {
  const res = await putData(`material/repairs/${id}`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsCutoffsList = async (q, b, page, rowsPerPage) => {
  let _params = `${q ? "&lendsNo=" + q : ""}${
    b ? (b !== "all" ? "&branchNo=" + b : "") : ""
  }`;
  const res = await getData(
    `material/cutoffs?page=${page}&limit=${rowsPerPage}` + _params
  );
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};

export const addMaterialsCutoffs = async (body) => {
  const res = await postData(`material/cutoffs`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const getMaterialsCutoffsDetail = async (id) => {
  const res = await getData(`material/cutoffs/${id}`);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
export const updateMaterialsCutoffs = async (body, id) => {
  const res = await putData(`material/cutoffs/${id}`, body);
  if (res.status === true) {
    return res.result;
  } else {
    return null;
  }
};
